import { tapLight } from '../lib/haptics';

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Accessible name — the visual carries no text. */
  label: string;
}

/**
 * A sliding on/off switch: the state reads at a glance from the thumb
 * position and track colour, replacing the old "On"/"Off" word-buttons.
 */
export function Switch({ checked, onChange, disabled = false, label }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      className="switch"
      disabled={disabled}
      onClick={() => {
        tapLight();
        onChange(!checked);
      }}
    >
      <span className="switch-thumb" aria-hidden="true" />
    </button>
  );
}
